import React, { useRef, useState } from 'react';

export const GiaReportLookup = () => {
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const input = useRef<HTMLInputElement>(null);
  const reportNumber = value.trim().replace(/^GIA[\s:#-]*/i, '').replace(/[\s-]+/g, '');

  return <section id="tra-cuu-gia" aria-labelledby="gia-lookup-heading" className="tw-scroll-mt-6 tw-rounded-lg tw-border tw-border-jr-line tw-bg-white tw-p-5 sm:tw-p-6">
    <h2 id="gia-lookup-heading" className="tw-m-0 tw-text-[16px] tw-font-medium">Bạn đã có số báo cáo GIA?</h2>
    <p className="tw-mt-2 tw-mb-4 tw-text-[13px] tw-leading-relaxed tw-text-jr-mute">Nhập số báo cáo để xem thông số và đối chiếu bản gốc tại GIA.</p>
    <form aria-label="Tra cứu báo cáo GIA" onSubmit={(event) => {
      event.preventDefault();
      if (!/^\d{1,20}$/.test(reportNumber)) {
        setError('Vui lòng nhập số báo cáo GIA, chỉ gồm chữ số.');
        input.current?.focus();
      } else {
        setError('');
        window.open(`https://www.gia.edu/report-check?locale=en_US&reportno=${encodeURIComponent(reportNumber)}`, '_blank', 'noopener,noreferrer');
      }
    }}>
      <label htmlFor="gia-report-number" className="tw-mb-2 tw-block tw-text-[13px] tw-font-medium tw-text-jr-green">Số báo cáo GIA</label>
      <div className="tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row">
        <input id="gia-report-number" ref={input} type="text" inputMode="numeric" enterKeyHint="go" autoComplete="off" spellCheck={false} required maxLength={64} value={value} onChange={(event) => { setValue(event.target.value); setError(''); }} placeholder="Ví dụ: 2141438171" aria-invalid={!!error} aria-describedby={error ? 'gia-report-error gia-report-hint' : 'gia-report-hint'} className="tw-h-11 tw-w-full tw-min-w-0 tw-flex-1 tw-rounded tw-border tw-border-jr-line tw-bg-white tw-px-3 tw-text-[16px] focus:tw-border-jr-green focus:tw-outline-none" />
        <button type="submit" className="tw-flex tw-min-h-[44px] tw-shrink-0 tw-items-center tw-justify-center tw-gap-2 tw-rounded tw-border-0 tw-bg-jr-green tw-px-4 tw-text-[13px] tw-font-medium tw-text-white hover:tw-opacity-90 focus-visible:tw-outline-jr-gold">Tra cứu trên GIA <span aria-hidden="true">↗</span></button>
      </div>
      {error && <p id="gia-report-error" role="alert" className="tw-mt-2 tw-mb-0 tw-text-[13px] tw-text-[#AA3636]">{error}</p>}
      <p id="gia-report-hint" className="tw-mt-3 tw-mb-0 tw-text-[12px] tw-text-jr-mute">Kết quả mở trên gia.edu trong tab mới.</p>
    </form>
  </section>;
};
